/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tools_Legajox_Ingest_SuccessInputs */

const es_tools_legajox_ingest_success = /** @type {(inputs: Tools_Legajox_Ingest_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Archivos de Legajox ingestados`)
};

const en_tools_legajox_ingest_success = /** @type {(inputs: Tools_Legajox_Ingest_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Legajox files ingested`)
};

/**
* | output |
* | --- |
* | "Legajox files ingested" |
*
* @param {Tools_Legajox_Ingest_SuccessInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const tools_legajox_ingest_success = /** @type {((inputs?: Tools_Legajox_Ingest_SuccessInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tools_Legajox_Ingest_SuccessInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_tools_legajox_ingest_success(inputs)
	return en_tools_legajox_ingest_success(inputs)
});
export { tools_legajox_ingest_success as "tools.legajox.ingest_success" }